import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import {
  claimsClosingText,
  claimsContactText,
  claimsIncidents,
  claimsReminders
} from '../../content/claimsPolicy';

const TerminosCondiciones = () => {
  return (
    <>
      <Helmet>
        <title>Condiciones Generales | Jarad</title>
        <meta name="description" content="Condiciones generales de contratación de Jarad. Regulación de la compra de bienes a través del sitio web." />
      </Helmet>

      <div className="bg-gray-50 py-12">
        <motion.div
          className="container mx-auto px-4 max-w-4xl"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="bg-white shadow-sm rounded-lg p-8 md:p-12">
            <h1 className="text-3xl font-bold text-gray-900 mb-8 border-b pb-4">
              CONDICIONES GENERALES DE CONTRATACIÓN
            </h1>

            <div className="prose prose-blue max-w-none text-gray-600">

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">Introducción</h2>
                <p className="mb-4">
                  Este documento contractual regirá las Condiciones Generales de contratación en la compra de bienes que
                  puedan deteriorarse o caducar con rapidez (en adelante, «Condiciones») a través del sitio web
                  semillasjarad.es/, propiedad de VALLE GALBARRO S.L. bajo la marca comercial de VALLE GALBARRO S.L.,
                  en adelante, PRESTADOR, cuyos datos de contacto figuran también en el Aviso Legal de esta Web.
                </p>
                <p className="mb-4">
                  Estas Condiciones permanecerán publicadas en el sitio web a disposición del USUARIO para reproducirlas y
                  guardarlas como confirmación del contrato, pudiendo ser modificadas en cualquier momento por el
                  PRESTADOR. Es responsabilidad del USUARIO leerlas periódicamente, ya que resultarán aplicables aquellas
                  que se encuentren vigentes en el momento de realización de pedidos.
                </p>
                <p className="mb-4">
                  Los contratos no estarán sujetos a formalidad alguna con excepción de los supuestos expresamente señalados
                  en los Códigos Civil y de Comercio y en esta o en otras leyes especiales.
                </p>
                <p className="mb-2">La aceptación de este documento conlleva que el USUARIO:</p>
                <ul className="list-disc pl-5 mb-4 space-y-1">
                  <li>Ha leído, entiende y comprende lo aquí expuesto.</li>
                  <li>Es una persona con capacidad suficiente para contratar.</li>
                  <li>Asume todas las obligaciones aquí dispuestas.</li>
                </ul>
                <p className="mb-4">
                  Estas condiciones tendrán un período de validez indefinido y serán aplicables a todas las contrataciones
                  realizadas a través del sitio web del PRESTADOR.
                </p>
                <p>
                  El PRESTADOR informa de que el comercio es responsable y conoce la legislación vigente de los países a los
                  que envía los productos, y se reserva el derecho de modificar unilateralmente las condiciones, sin que ello
                  pueda afectar a los bienes o promociones que fueron adquiridos previamente a la modificación.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">Identidad de las partes contratantes</h2>
                <p className="mb-4">
                  Por un lado, el PRESTADOR de los alimentos contratados por el USUARIO es VALLE GALBARRO S.L., con
                  domicilio social en C/ Ctra. de Utrera, 19-A 41760 El Coronil - Sevilla, NIF B41658154 y con teléfono de
                  atención al cliente/USUARIO +34 955 83 68 23.
                </p>
                <p>
                  Y de otro, el USUARIO, registrado en el sitio web mediante un nombre de usuario y contraseña, sobre los que
                  tiene responsabilidad plena de uso y custodia, y es responsable de la veracidad de los datos personales
                  facilitados al PRESTADOR.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">Objeto del contrato</h2>
                <p className="mb-4">
                  El presente contrato tiene por objeto regular la relación contractual de compraventa nacida entre el
                  PRESTADOR y el USUARIO en el momento en que este acepta durante el proceso de contratación en línea la
                  casilla correspondiente.
                </p>
                <p>
                  La relación contractual de compraventa conlleva la entrega, a cambio de un precio determinado y públicamente
                  expuesto a través del sitio web, de un producto alimentario determinado.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">Procedimiento de contratación</h2>
                <p className="mb-4">
                  El USUARIO, para poder acceder a los productos que ofrece el PRESTADOR, deberá ser mayor de edad y
                  darse de alta a través del sitio web mediante la creación de una cuenta de usuario. Por ello, el USUARIO
                  deberá proporcionar de manera libre y voluntaria los datos personales que se le requerirán, los cuales se
                  tratarán de conformidad con lo dispuesto en el Reglamento (UE) 2016/679, de 27 de abril de 2016 (RGPD),
                  relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre
                  circulación de estos datos y la Ley Orgánica 3/2018, de 5 de diciembre (LOPDGDD), relativa a la protección de
                  datos de carácter personal y detallada en el Aviso legal y en la Política de privacidad de este sitio web.
                </p>
                <p className="mb-4">
                  El USUARIO seleccionará un nombre de usuario y una contraseña, comprometiéndose a hacer un uso
                  diligente de los mismos y a no ponerlos a disposición de terceros, así como a comunicar al PRESTADOR la
                  pérdida o robo de los mismos o el posible acceso por un tercero no autorizado, de manera que este proceda al
                  bloqueo inmediato.
                </p>
                <p className="mb-4">
                  Una vez ha sido creada la cuenta de usuario, se informa de que conforme a lo que exige el artículo 27 de la
                  Ley 34/2002, de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSICE), el
                  procedimiento de contratación seguirá los siguientes pasos:
                </p>
                <ol className="list-decimal pl-5 space-y-1">
                  <li>Cláusulas generales de contratación, incluida la modificación de pedidos.</li>
                  <li>Envío y entrega de pedidos.</li>
                  <li>Derecho de desistimiento.</li>
                  <li>Reclamaciones y resolución de litigios en línea.</li>
                  <li>Fuerza mayor.</li>
                  <li>Competencia.</li>
                  <li>Generalidades de la oferta.</li>
                  <li>Precio y plazo de validez de la oferta.</li>
                  <li>Gastos de transporte.</li>
                  <li>Forma de pago, gastos y descuentos.</li>
                  <li>Proceso de compra.</li>
                  <li>Disociación y suspensión o rescisión del contrato.</li>
                  <li>Ley aplicable y jurisdicción.</li>
                </ol>
              </div>

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">1. CLÁUSULAS GENERALES DE CONTRATACIÓN</h2>
                <p className="mb-6">
                  Salvo estipulación particular por escrito, la realización de un pedido al PRESTADOR supondrá la aceptación
                  por parte del USUARIO de estas condiciones legales. Ninguna estipulación hecha por el USUARIO podrá
                  diferir de las del PRESTADOR si no ha sido expresamente aceptada por adelantado y por escrito por el
                  PRESTADOR.
                </p>

                <h3 className="text-lg font-bold text-gray-800 mb-3">Modificación de pedidos</h3>
                <p className="mb-4">
                  El cliente podrá solicitar la modificación de un pedido realizado a través de la tienda online durante las
                  primeras 48 horas desde su confirmación.
                </p>
                <p className="mb-4">
                  Para ello, deberá ponerse en contacto con Jarad Pet Food e indicar el número de pedido y los cambios
                  solicitados. Transcurrido dicho plazo, el pedido se considerará definitivo y no será posible realizar
                  modificaciones.
                </p>
                <p className="mb-4">
                  Las modificaciones estarán sujetas a la disponibilidad de los productos y al estado de preparación del pedido.
                  Si el pedido ya hubiera sido preparado, expedido o entregado a la empresa de transporte antes de que finalice
                  el plazo indicado, Jarad Pet Food no podrá garantizar que la modificación pueda realizarse.
                </p>
                <p>
                  Esta condición se refiere únicamente a modificaciones del pedido y no afecta a los derechos de cancelación,
                  desistimiento o devolución que resulten aplicables conforme a la legislación vigente y a las restantes
                  condiciones de compra.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">2. ENVÍO Y ENTREGA DE PEDIDOS</h2>
                <p className="mb-4">
                  El plazo de entrega estará comprendido entre 2 y 6 días laborables, según la población de destino y la forma
                  de pago elegida. Se entiende este término siempre que se haya confirmado la disponibilidad de la mercancía y
                  comprobado el pago completo del pedido.
                </p>
                <p className="mb-4">
                  En caso de que el PRESTADOR no hubiera realizado la entrega de la mercancía, transcurridos 30 días
                  naturales desde la fecha de entrega pactada, por falta de disponibilidad del producto o servicio, el USUARIO
                  será informado y quedará legitimado para cancelar el pedido y recibir la devolución del importe total pagado sin
                  ningún coste, y sin que por ello se derive ninguna responsabilidad por daños y perjuicios imputable al
                  PRESTADOR.
                </p>
                <p className="mb-4">
                  En caso de retraso injustificado por parte del PRESTADOR respecto a la devolución del importe total, el
                  USUARIO podrá reclamar que se le pague el doble del importe adeudado, sin perjuicio a su derecho de ser
                  indemnizado por los daños y perjuicios sufridos en lo que excedan de dicha cantidad.
                </p>
                <p className="mb-4">
                  El PRESTADOR no asumirá ninguna responsabilidad cuando la entrega del producto o servicio no llegue a
                  realizarse, por ser los datos facilitados por el USUARIO, falsos, inexactos o incompletos.
                </p>
                <p className="mb-4">
                  La entrega se considerará realizada en el momento en que el transportista haya puesto los productos a
                  disposición del USUARIO y este, o el delegado de este, haya firmado el documento de recepción de la
                  entrega.
                </p>
                <p>
                  Corresponde al USUARIO verificar los productos a la recepción y exponer todas las salvedades y
                  reclamaciones que puedan estar justificadas en el documento de recepción de la entrega.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">3. DERECHO DE DESISTIMIENTO</h2>
                <p className="mb-4">
                  Los alimentos que se ofertan son perecederos, es decir, que pueden caducar o deteriorarse en un corto
                  período de tiempo. Este tipo de suministro de bienes queda exento de devolución, según el inciso d) del
                  artículo 103 de la Ley 3/2014, de 27 de marzo.
                </p>
                <p className="mb-4">
                  De todos modos, se ofrece al USUARIO la posibilidad de reclamar los posibles vicios o defectos que presente
                  el pedido en un plazo de 24 horas desde la entrega, tanto en modo en línea como fuera de línea, y, si se
                  considera, realizar la devolución.
                </p>
                <p className="mb-4">
                  Toda devolución deberá comunicarse al PRESTADOR, por correo electrónico a info@semillasjarad.es,
                  indicando el número de factura o pedido correspondiente. Una vez el USUARIO haya recibido el número de
                  devolución, hará llegar el producto al PRESTADOR, indicando este número en la carta de envío, con los
                  gastos de transporte a su cargo, en el domicilio de VALLE GALBARRO S.L., C/ Ctra. de Utrera, 19-A 41760 El
                  Coronil - Sevilla
                </p>
                <p>
                  Analizado el caso, si el PRESTADOR considera que el producto no cumplía las condiciones de venta, en un
                  plazo de 48 horas informará al USUARIO del importe y condiciones de su reembolso.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">4. RECLAMACIONES</h2>
                <div className="overflow-x-auto mb-6">
                  <table className="min-w-full border-collapse text-sm">
                    <thead>
                      <tr className="bg-gray-100 text-gray-800">
                        <th scope="col" className="border border-gray-300 px-4 py-3 text-left font-semibold">Incidencia</th>
                        <th scope="col" className="border border-gray-300 px-4 py-3 text-left font-semibold">Qué hacer</th>
                        <th scope="col" className="border border-gray-300 px-4 py-3 text-left font-semibold">Plazo / Condiciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {claimsIncidents.map(({ incident, action, conditions }) => (
                        <tr key={incident} className="align-top odd:bg-white even:bg-gray-50">
                          <th scope="row" className="border border-gray-300 px-4 py-3 text-left font-semibold text-gray-800">
                            {incident}
                          </th>
                          <td className="border border-gray-300 px-4 py-3">{action}</td>
                          <td className="border border-gray-300 px-4 py-3">{conditions}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <h3 className="text-lg font-bold text-gray-800 mb-2">Recordatorio</h3>
                <ul className="list-disc pl-5 mb-4 space-y-1">
                  {claimsReminders.map((reminder) => (
                    <li key={reminder}>{reminder}</li>
                  ))}
                </ul>
                <p className="mb-4">{claimsClosingText}</p>
                <p>{claimsContactText}</p>
              </div>

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">5. FUERZA MAYOR</h2>
                <p>
                  Las partes no incurrirán en responsabilidad ante cualquier falta debida a causa mayor. El cumplimiento de la
                  obligación se demorará hasta el cese del caso de fuerza mayor.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">6. COMPETENCIA</h2>
                <p className="mb-4">
                  El USUARIO no podrá ceder, transferir o transmitir los derechos, responsabilidades y obligaciones contratados
                  en la venta.
                </p>
                <p className="mb-4">
                  Si alguna estipulación de estas condiciones fuera considerada nula o de imposible cumplimiento, la validez,
                  legalidad y cumplimiento del resto no se verán afectados de ninguna manera, ni sufrirán modificación de
                  ningún modo.
                </p>
                <p>
                  El USUARIO declara haber leído, conocer y aceptar las presentes Condiciones en toda su extensión.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">7. GENERALIDADES DE LA OFERTA</h2>
                <p className="mb-4">
                  Todas las ventas y entregas efectuadas por el PRESTADOR se entenderán sometidas a las presentes
                  Condiciones.
                </p>
                <p className="mb-4">
                  Ninguna modificación, alteración o pacto contrario a la Propuesta Comercial de VALLE GALBARRO S.L. o a lo
                  aquí estipulado, tendrá efecto, salvo pacto expreso por escrito firmado por el PRESTADOR, en este caso,
                  estos pactos particulares prevalecerán.
                </p>
                <p>
                  El PRESTADOR se reserva la facultad de modificar sus especificaciones respecto de la información facilitada
                  en su publicidad, hasta que no afecte el valor de los productos ofrecidos. Estas modificaciones tendrán
                  asimismo validez en caso de que, por cualquier causa, se viera afectada la posibilidad de suministro de los
                  productos ofrecidos.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">8. PRECIO Y PLAZO DE VALIDEZ DE LA OFERTA</h2>
                <p className="mb-4">
                  Los precios que se indican respecto de cada producto se muestran conforme a las condiciones comerciales
                  aplicables a cada cliente. Estos precios, a menos que se indique expresamente lo contrario,
                  no incluyen los gastos de envío, manipulación, envoltorio, seguro de envíos o cualesquiera otros servicios
                  adicionales y anexos al producto adquirido.
                </p>
                <p className="mb-4">
                  Los precios aplicables a cada producto son los publicados en el sitio web y se expresarán en la moneda
                  EURO. El USUARIO asume que la valoración económica de algunos de los productos podrá variar en tiempo
                  real.
                </p>
                <p className="mb-4">
                  Antes de realizar la compra, el USUARIO podrá comprobar en línea todos los detalles del presupuesto:
                  artículos, cantidades, precio, disponibilidad, gastos de transporte, cargos, descuentos, impuestos y el total de
                  la compra. Los precios pueden cambiar diariamente mientras no se realice el pedido.
                </p>
                <p className="mb-4">
                  Una vez realizado el pedido, los precios se mantendrán tanto si hay disponibilidad de productos como si no.
                </p>
                <p className="mb-4">
                  Todo pago realizado al PRESTADOR conlleva la emisión de una factura a nombre del USUARIO registrado o
                  de la razón social que este haya informado en el momento de realizar el pedido. Esta factura se enviará en
                  formato papel junto con el producto adquirido. Se podrá descargar la factura en formato PDF accediendo al
                  panel de gestión de la web con la cuenta de usuario. En caso de querer recibirla mediante correo electrónico,
                  deberá solicitarlo por cualquiera de los medios que el PRESTADOR pone a su disposición, informándole de
                  que en cualquier momento podrá revocar dicha decisión.
                </p>
                <p>
                  Para cualquier información sobre el pedido, el USUARIO podrá contactar a través del teléfono de atención al
                  cliente del PRESTADOR +34 955 83 68 23 o vía correo electrónico a la dirección info@semillasjarad.es.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">9. GASTOS DE TRANSPORTE</h2>
                <p className="mb-4">
                  Los precios no incluyen gastos de envío o prestaciones complementarias, salvo pacto expreso por escrito en
                  contrario.
                </p>
                <p className="mb-4">
                  Los portes se calcularán en el momento de guardar la cesta o presupuesto, ya que se calculan por el peso de
                  los productos y por la dirección de entrega.
                </p>
                <p className="mb-2">La tarifa máxima de transporte aplicada es la siguiente:</p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Península hasta 2 Kg: .......... €</li>
                  <li>Península &gt; 2 Kg hasta 10 Kg: .......... €</li>
                  <li>Península &gt; 10 Kg: .......... €</li>
                  <li>Fuera península hasta 2 Kg: .......... €</li>
                  <li>Fuera península &gt; 2 Kg hasta 10 Kg: .......... €</li>
                  <li>Fuera península &gt; 10 Kg: .......... €</li>
                </ul>
              </div>

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">10. FORMAS DE PAGO, CARGOS Y DESCUENTOS</h2>
                <p className="mb-4">
                  El PRESTADOR es el responsable de las transacciones económicas y posibilita las siguientes formas para
                  efectuar el pago de un pedido:
                </p>
                <ul className="list-disc pl-5 mb-4 space-y-1">
                  <li>Transferencia bancaria</li>
                  <li>Contra reembolso</li>
                  <li>Tarjeta de crédito</li>
                </ul>
                <p className="mb-6">
                  El USUARIO podrá utilizar un cupón de descuento en el momento previo a la finalización de la compra en caso
                  de haberlo recibido por parte del PRESTADOR.
                </p>

                <h3 className="text-lg font-bold text-gray-800 mb-2">Medidas de seguridad</h3>
                <p className="mb-4">
                  El sitio web utiliza técnicas de seguridad de la información generalmente aceptadas en la industria, tales como
                  SSL, datos introducidos en página segura, firewalls, procedimientos de control de acceso y mecanismos
                  criptográficos, todo ello con el objeto de evitar el acceso no autorizado a los datos. Para lograr estos fines, el
                  usuario/cliente acepta que el prestador obtenga datos para efecto de la correspondiente autenticación de los
                  controles de acceso.
                </p>
                <p className="mb-4">
                  El PRESTADOR se compromete a no permitir ninguna transacción que sea o sea considerada ilegal por las
                  marcas de tarjetas de crédito o el banco adquiriente, que pueda o tenga el potencial de dañar la buena
                  voluntad de los mismos o influir de manera negativa en ellos.
                </p>
                <p>
                  Las siguientes actividades están prohibidas en virtud de los programas de las marcas de tarjetas: la venta u
                  oferta de un producto o servicio que no cumpla con todas las leyes aplicables al Comprador, Banco Emisor,
                  Comerciante o Titular de la tarjeta o tarjetas.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">11. PROCESO DE COMPRA</h2>
                <p className="mb-4">
                  Cualquier producto del catálogo se puede añadir a la cesta. En esta, solo se observarán los artículos, la
                  cantidad, el precio y el importe total. Una vez guardada la cesta se procederá a calcular los impuestos, cargos
                  y descuentos según los datos de pago y de envío introducidos.
                </p>
                <p className="mb-4">
                  Las cestas no tienen ninguna vinculación administrativa, solo es un apartado donde se puede simular un
                  presupuesto sin ningún compromiso por ambas partes.
                </p>
                <p className="mb-4">
                  Desde la cesta se puede hacer un pedido siguiendo los pasos siguientes para su correcta formalización:
                </p>
                <ol className="list-decimal pl-5 mb-4 space-y-1">
                  <li>Comprobación de los datos de facturación.</li>
                  <li>Comprobación de la dirección de envío.</li>
                  <li>Selección de la forma de pago.</li>
                  <li>Realizar el pedido (comprar).</li>
                </ol>
                <p>
                  Una vez procesado el pedido, el sistema envía instantáneamente un correo electrónico al departamento de
                  gestión del PRESTADOR y otro al correo del USUARIO confirmando la realización del pedido, su estado y la
                  fecha de envío y/o entrega aproximada.
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">12. DISOCIACIÓN Y SUSPENSIÓN O RESCISIÓN DEL CONTRATO</h2>
                <p className="mb-4">
                  Si cualquiera de estos términos y condiciones se considerara ilegal, nula o por cualquier razón inaplicable, esta
                  condición se considerará separable y no afectará la validez y aplicabilidad de ninguna de las condiciones
                  restantes.
                </p>
                <p className="mb-4">
                  VALLE GALBARRO S.L. podrá, sin previo aviso, suspender o terminar el acceso del USUARIO a sus servicios
                  de e-commerce, en su totalidad o en parte, por cualquier razón válida, incluyendo, sin limitaciones, cuando el
                  USUARIO no cumpla o siga cualquiera de las obligaciones establecidas en este documento o cualquier
                  disposición legal, licencia, reglamento, directiva, código de prácticas o políticas de uso aplicables.
                </p>
                <p>
                  Cuando VALLE GALBARRO S.L. ejerza cualquiera de sus derechos o facultades bajo esta Cláusula, tal
                  ejercicio no perjudicará ni afectará el ejercicio de cualquier otro derecho, facultad o recurso que pueda estar a
                  disposición de VALLE GALBARRO S.L..
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">13. LEY APLICABLE Y JURISDICCIÓN</h2>
                <p className="mb-4">
                  Estas condiciones se regirán o interpretarán conforme a la legislación española en aquello que no esté
                  expresamente establecido. El PRESTADOR y el USUARIO acuerdan someter a los juzgados y tribunales del
                  domicilio del USUARIO cualquier controversia que pudiera suscitarse de la prestación de los productos o
                  servicios objeto de estas Condiciones.
                </p>
                <p>
                  En caso de que el USUARIO tenga su domicilio fuera de España, el PRESTADOR y el USUARIO renuncian
                  expresamente a cualquier otro foro, sometiéndose al Organismo de resolución de litigios que actuará de
                  intermediario entre ambos conforme al Art. 14.1 del Reglamento (UE) 524/2013, sin necesidad de recurrir a los
                  tribunales de justicia. Para más información, consulte la cláusula «4. RECLAMACIONES Y RESOLUCIÓN DE
                  LITIGIOS EN LÍNEA» de estas Condiciones.
                </p>
              </div>

            </div>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default TerminosCondiciones;
